<template>
    <div>
        <card-header title="Certifications" icon="fa-certificate"/>

        <card-toolbar>
            <button @click="$openCard('new-certification', {}, card)"><i class="far fa-plus"></i>New Certification</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <certification-tile
                    :card="card"
                    :certification="c"
                    v-for="c in certifications"
                    @click="$openCard('edit-certification', {certificationId: c.id}, card)"
                    :active="child && child.definition.component === 'edit-certification' && child.props.certificationId == c.id"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardToolbar from "@/TIER/components/CardToolbar";

    import CertificationTile from "@/components/tiles/CertificationTile";

    import {client as http} from "@/http_client";

    export default {
        components: {CertificationTile, CardToolbar, CardHeader, CardBody, CardList},
        props: ['card', 'child'],
        data() {
            return {
                certifications: []
            }
        },
        methods: {
            loadCertifications: function (force) {
                this.$emit('loading', true);

                http.get('certs', {force}).then(response => {
                    this.certifications = response.data;
                    this.$emit('loading', false);
                }, err => {
                    console.log(err);
                });
            },
            reload: function() {
                this.loadCertifications(true);
            }
        },
        mounted: function() {
            this.loadCertifications();
        }
    }
</script>
